<template>
  <div style="width:100%" class="p-3"> 
    <div  v-if="windowSize>=992" class="d-none d-md-block" >
      <b-row>     
        <b-col  class="p-0">
          <b-input-group
            size="sm"
            class="mb-3 sw-search"
            prepend="Buscar"
          >
            <b-form-input  :autofocus="saveConfig.autofocus" v-model="currentSearch" placeholder="Escribe aquí para filtrar los resultados"></b-form-input>
            <b-input-group-append>
                <b-button size="sm" 
              style="background:#e9ecef;color:#495057;border: 1px solid #ced4da;" text="Button" variant="info">txt</b-button>
              </b-input-group-append>
              <b-input-group-append>
                <b-button size="sm" 
              style="background:#e9ecef;color:#495057;border: 1px solid #ced4da;" text="Button" variant="secondary">Pdf</b-button>
              </b-input-group-append>
              <b-input-group-append>
                <b-button size="sm" 
              style="background:#e9ecef;color:#495057;border: 1px solid #ced4da;" text="Button" variant="success" class="search-radius">Excell</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>       
        <table style="margin-bottom:0" class="table table--get table-hover border box-effect linear table-sm table-bordered sw-table-dark">
          <thead  class="table-dark ">         
            <tr>
              <th v-for="(items,index) in tableItems" :key="'thtableGet'+index"> 
                  {{items.thead.th}}         
                  <span @click="items.thead.sort=sort(items.thead.sort,items.thead.sortTable,index)" class="sw-sort" v-if="items.thead.sort!==undefined" :class="{'sw-sortdown': items.thead.sort===false, 'sw-sortup': items.thead.sort===true}"></span>
              </th>
              <th class="text-right"  v-if="tableOptions!=='' && typeof tableOptions === 'object'">              
                    Opciones 
              </th>
            </tr>
          </thead>
          <tbody class="tabletableinput"  style="background: white">   
            <tr>            
            </tr>
            <tr @mouseover="handleHover(true,index)" :class="{'bg-hover-td':isHovered[index]}"  v-for="(items,index) in sortedTable()" :key="'dataGetTabletable'+index">    
              <validation-observer v-slot="{ invalid, errors }" style="display:contents">  
                <td v-for="(items2,index2) in tableItems" :key="'tdGet'+index2"> 
                  <div v-if="!items2.tbody.input">
                    <div v-if="!items2.tbody.link" :class="items2.tbody.class">
                      <span   v-for="(items4,index4) in items2.tbody.td" :key="'inputstable'+index4">
                        <span v-if="items2.tbody.checks">
                          <span v-if="items[items4]===true">
                            {{items2.tbody.checks[index4]}}  
                          </span>                  
                        </span>
                        <span v-else>
                          <span v-if="items4.includes('text/')">
                              {{items4.replace('text/','')}}
                          </span>
                          <span v-if="items2.tbody.ftn!==undefined">
                                  {{items2.tbody.ftn(items,tableIndex)}}
                          </span>
                          <span v-else>
                            <span v-if="items4==='id_list' && items.name_list!==null">
                              {{gettersDatalist(items.name_list,items[items4])[0].name}} 
                            </span>
                            <span v-else>
                              {{items[items4]}}
                            </span>                        
                          </span>                                       
                        </span>
                      </span>  
                    </div>  
                    <div v-else>
                        <b-button variant="white" size="sm" @click="openLinks(items2.tbody.link,items[items2.tbody.td[0]])" class="btn-link">Pdf</b-button>
                    </div>                              
                  </div>
                  <div v-if="items2.tbody.input">
                      <sw-inputstabletable
                        v-for="(items4,index4) in items2.tbody.td" :key="'inputstable'+index4"
                        :inputTabla="tabla"
                        :inputCampo="items4"
                        :index="items.index"
                        :indexIndex="tableIndex"
                        >
                      </sw-inputstabletable>
                  </div>
                </td> 
                <td class="text-right" v-if="tableOptions!=='' && typeof tableOptions === 'object' && !tableOptions.isNotOption" > 
                    <div v-show="isHovered[index]" style="display:inline-block;padding-left:5px;padding-right:5px" v-for="(items2,index2) in tableOptions" :key="'optionsTables'+index2">
                      <b-icon :id="index+'optionsTableguardar'+index2" class="option-btn" :icon="items2.icon" scale="1.7" :variant="items2.variant"></b-icon>
                      <b-popover
                        :target="index+'optionsTableguardar'+index2"
                        placement="bottom"
                        :title="items2.msj"
                        triggers="hover"
                      >
                        <template v-slot:default>
                          <div class="text-center mt-3">
                            
                            <b-form-group  v-for="(items3,index3) in items2.inputsTable" :key="'inputs'+index2+index3"
                              :label="datadb[inputData(items3).table][inputData(items3).campo].label"
                              >
                              <sw-inputstabletable
                                  :inputTabla="inputData(items3).table"
                                  :inputCampo="inputData(items3).campo"
                                  :index="items.index"
                                  :indexIndex="tableIndex"
                                  >
                                </sw-inputstabletable>

                            </b-form-group>
                            <sw-inputs
                              class="text-left"
                              v-for="(items3,index3) in items2.inputs" :key="'inputs'+index2+index3"
                              :inputTabla="inputData(items3).table"
                              :inputCampo="inputData(items3).campo"
                              :lg="12"
                              :md="12"
                            ></sw-inputs>
                            <b-button 
                              :disabled="items2.invalidFtn(invalid,errors,tableIndex,namePath,items.index)"
                              v-if="!saveConfig.capa" 
                              size="sm" 
                              @click="save(items2.ftn,items,items2.inputs)" :variant="items2.variant">                            
                              {{items2.btn}}
                            </b-button>
                            <b-button  
                              v-if="saveConfig.capa" 
                              disabled 
                              :variant="items2.variant"
                              size="sm" 
                              class="ml-2 sw-save-loading" 
                              ><div> <b-spinner variant="light" label="Spinning"></b-spinner></div>{{items2.btn}}</b-button>
                          </div>
                        </template>                  
                      </b-popover>
                    </div>                 
                </td>  
              </validation-observer>             
            </tr> 
          </tbody>
        </table>     
        <div v-if="tableOptions.saveBtn">
          <b-button class="mt-2" variant="primary" @click="saveBtn(tableOptions.saveBtn.ftn, sortedTable())">{{tableOptions.saveBtn.btn}}</b-button>
        </div> 
      <b-row v-if="sortedTable().length>10">    
        <b-col md="3" class="p-0">
          <b-pagination style="margin-bottom:0" class="paginatable" v-model="pagination" :total-rows="rows" size="sm" first-number  align="fill"></b-pagination>
        </b-col> 
        <b-col  class="p-0">
        </b-col>
      </b-row>
    </div>
    <div  v-if="windowSize<992" class="d-md-none">
      <table   style="margin-bottom:0" class="table table--get table-hover border box-effect linear">
        <thead>
          <tr>
            <th  v-for="(items,index) in tableItems" :key="'thGetMovil'+index" v-if="items.thead.movil">{{items.thead.th}}</th>
            <th>Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr  v-for="(items,index) in sortedTable()" :key="'dataGetTableMovil'+index" style="position:relative">
            <td   v-for="(items2,index2) in tableItems" :key="'thGetMovil'+index2" v-if="items2.thead.movil && items.tableTable===undefined">
              {{items[items2.tbody.td[0]]}}
            </td> 
            <td style="background: #f0f0f0" :colspan="colspan()"  v-if="items.tableTable!==undefined"> 
              <validation-observer v-slot="{ invalid, errors }" style="display:contents">  
              <table>
                <tbody>
                  <tr style="background: #fff" v-for="(items2,index2) in tableItems" :key="'tdGet'+index2">
                    <td>{{items2.thead.th}}</td>
                    <td>
                      <div v-if="!items2.tbody.input">
                        <div v-if="!items2.tbody.link" >                          
                          <span v-if="!items2.tbody.ftn">
                            <span v-for="(items4,index4) in items2.tbody.td" :key="'inputstable'+index4">
                              <span v-if="items2.tbody.checks">
                                <span v-if="items[items4]===true">
                                  {{items2.tbody.checks[index4]}}  
                                </span>                  
                              </span>
                              <span v-else>
                                <span v-if="items4.includes('text/')">
                                    {{items4.replace('text/','')}}
                                </span>
                                <span v-else>
                                  <span v-if="items4==='id_list' && items.name_list!=null">
                                    {{gettersDatalist(items.name_list,items[items4])[0].name}} 
                                  </span>
                                  <span v-else>
                                    {{items[items4]}}
                                  </span>                        
                                </span>                                       
                              </span>
                            </span>                          
                          </span>                           
                          <span v-else>
                            <span v-if="items2.tbody.ftn!==undefined">
                              {{items2.tbody.ftn(items,tableIndex-1)}}
                            </span>                          
                          </span> 
                        </div>  
                        <div v-else>
                            <b-button variant="white" size="sm" @click="openLinks(items2.tbody.link,items[items2.tbody.td[0]])" class="btn-link">Pdf</b-button>
                        </div>                              
                      </div>
                      <div v-if="items2.tbody.input">
                          <sw-inputstabletable
                            v-for="(items4,index4) in items2.tbody.td" :key="'inputstable'+index4"
                            :inputTabla="tabla"
                            :inputCampo="items4"
                            :index="items.index"
                            :indexIndex="tableIndex"
                            >
                          </sw-inputstabletable>
                      </div>
                    </td>
                  </tr>
                  <tr  style="background: #fff;">
                    <td></td>
                    <td style="text-align:right;" v-if="tableOptions.save!==undefined">
                      <b-button :disabled="tableOptions.save.invalidFtn(invalid,errors,tableIndex-1,namePath,items.index)" @click="openModalMovil(tableOptions.save,items)" :variant="tableOptions.save.variant">{{tableOptions.save.btn}}</b-button>
                    </td>                   
                  </tr>
                </tbody>
              </table>
              </validation-observer>   
            </td>
            <td   v-if="items.tableTable===undefined">
              <div style="display:inline-block;padding-left:5px;padding-right:5px">
                <div style="display:inline-block;padding-left:5px;padding-right:15px">
                  <b-icon class="option-btn" icon="list-ul" scale="1.7" variant="secondary" @click="openTableMovil(index,items);items.tableTable!=items.tableTable"></b-icon>
                </div>                 
              </div> 
              <div style="display:inline-block;padding-left:5px;padding-right:15px" v-for="(items2,index2) in tableOptions" :key="'optionsTables'+index2" v-if="index2!=='save'">
                  <b-icon  @click="openModalMovil(items2,items)" class="option-btn" :icon="items2.icon" scale="1.6" :variant="items2.variant"></b-icon>                 
                </div>      
            </td>
          </tr>
        </tbody>
      </table>
      <b-modal v-if="tableModal.value" v-model="tableModal.value" :title="tableModal.title" 
         content-class="shadow" >
        <div class="text-center mt-3">
          <p>{{tableModal.options.msj}}</p>
           <sw-inputs
            class="text-left"
            v-for="(items,index) in tableModal.options.inputs" :key="'inputsModal'+index"
            :inputTabla="inputData(index).table"
            :inputCampo="inputData(index).campo"
            :lg="12"
            :md="12"
          ></sw-inputs>
        </div>
        <template v-slot:modal-footer="{  cancel }">
            <b-button size="sm" variant="outline-secondary" @click="cancel()">
              Cerrar
            </b-button>
            <b-button 
              v-if="!saveConfig.capa" 
              size="sm" 
              @click="save(tableModal.options.ftn,tableModal.items,tableModal.options.inputs,1)" :variant="tableModal.options.variant">                            
              {{tableModal.options.btn}}
            </b-button>
            <b-button  
              v-if="saveConfig.capa" 
              disabled 
              :variant="tableModal.options.variant"
              size="sm" 
              class="ml-2 sw-save-loading" 
              ><div> <b-spinner variant="light" label="Spinning"></b-spinner></div>{{tableModal.options.btn}}
            </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>
<script>
import SwInputs from '@/components/forms/inputs.vue'
import SwInputstabletable from '@/components/forms/inputsTabletable.vue'
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import { ValidationObserver } from 'vee-validate'
function cleanParameter(value)
  {
    if(value==null)
    {
      return '';
    }
    return value.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
  }
export default 
{
  name: 'swTableget',
  components: { SwInputstabletable,SwInputs,ValidationObserver  },
  props: {
    tableSearch: {
      type: Array,
      default: function()
      {
        return []
      }
    },
    tableItems: {
      type: Array,
      default: function()
      {
        return []
      }
    },
    tableOptions: {
      default: function()
      {
        return ''
      }
    },
    name: {
      type: String,
      default: ''
    },
    tabla: {
      type: String,
      default: ''
    },
    tableIndex: {
      type: Number,
      default: 0
    },
  },
  data () {
    return {
      currentSearch:'',
      currentSort:'id',
      currentSortDir: '', 
      pagination: 1,
      rows: 100,
      tableModal: { 
        title: '',
        value: false,
        items: {},
        options: {}
      },
      tableTable: true,
      isHovered: [] 
    }
  },
  destroyed()
  {
    this.dataGet[this.namePath].data[this.tableIndex][this.tabla].splice(this.tableTable+1,1)
  },
  created()
  {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  methods: {  
    propsFtn(items,td)
    {
      let arrayItems= []
      for (let i = 0; i < td.length; i++) {
        arrayItems.push(items[td[i]])        
      }
      if(td.length>1)
      {
        return arrayItems
      }
      return items[td[0]]
      
    },
    handleHover(hovered,index) {
      this.isHovered=[]
      this.$set(this.isHovered,index,hovered)
    },
    handleResize(){
      this.windowSize = window.innerWidth;
    },    
    openLinks(link,id)
    {
      window.open( this.url+link+'?id='+id+'&token='+this.token,'_blank')
    },
    saveBtn(btn,items)
    { 
      this.$emit('save',{ftn: btn, data: items})
    },
    async save(btn,data,inputs,movil=0)
    {   
      let splits 
      let dataForm = {}
      let newData={}
      for (let m = 0; m < this.tableItems.length; m++) { 
        if(this.tableItems[m].tbody.input)
        {
          if(dataForm[this.tabla]===undefined)
          {
            dataForm[this.tabla]={} 
          }
          let dataKeys=Object.keys(data)
          for (let i = 0; i < dataKeys.length; i++)
          {
            if(!dataKeys[i].includes('/') && dataKeys[i]!=='index' && dataKeys[i]!=='tableTable')
            {
              dataForm[this.tabla][dataKeys[i]]=data[dataKeys[i]] 
            }                       
          }
        }        
      }

      if(inputs!==undefined)
      {
        for (let i = 0; i < inputs.length; i++) {
          splits=inputs[i].split('/')
          if(dataForm[splits[0]]===undefined)
          {
            dataForm[splits[0]]={} 
            dataForm[splits[0]].id=this.dataForm[this.namePath][splits[0]].id
            dataForm[splits[0]]['id_'+this.tabla]=data.id
          }
          dataForm[splits[0]][splits[1]]=this.dataForm[this.namePath][splits[0]][splits[1]]
        }
      }    
      if(movil===1)
      {
        await this.updateDataIndex({data: this.tableIndex-1})
      }
      else 
      {
        await this.updateDataIndex({data: this.tableIndex})
      }

      let tablesForm=Object.keys(dataForm)
      for (let i = 0; i < tablesForm.length; i++) {
        await this.updateDataForm({ state: tablesForm[i], data: dataForm[tablesForm[i]]})	 
      }      

      await this.$emit('save',btn)
    },
    sort(sort,td,index){   
      for(var i=0;i<this.tableItems.length;i++)
      {
        if(index!==i)
        {
          if(this.tableItems[i].thead.sort!==undefined)
          {
            this.tableItems[i].thead.sort=null
          }          
        }        
      }
      this.currentSort=td  
      this.currentSortDir = 'desc'
      if(sort===null || sort===false)
      {
        this.currentSortDir = 'asc'
        return true
      }
      return !sort
    },
    sortedTable(){
       let newTabla= this.tabla.split('/')
       let dataFilter = []
       if(newTabla.length===2)
       {
         dataFilter = this.deepCopyTable(this.dataGet[this.namePath].data[this.tableIndex][newTabla[0]][newTabla[1]]).filter(list => {  
               return this.tableSearch.find( items => {
              return cleanParameter(list[items]).indexOf(cleanParameter(this.currentSearch)) > -1
            })      
          })
       }
       else 
       {
          dataFilter = this.deepCopyTable(this.dataGet[this.namePath].data[this.tableIndex][this.tabla]).filter(list => {
           return this.tableSearch.find( items => {
              return cleanParameter(list[items]).indexOf(cleanParameter(this.currentSearch)) > -1
            })         
          })
       }      
       
           
        return dataFilter.sort((a,b) => {
          let modifier = 1;
          if(this.currentSortDir === 'desc') modifier = -1;
          if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier
          if(a[this.currentSort] > b[this.currentSort]) return  1 * modifier
          return 0
        });      
    },     
    colspan()
    {        
      let colspan=0
      if(this.tableOptions.options || this.tableOptions.modals)
      {
        colspan=1
      }
      return colspan + this.tableItems.length
    },
    async openTableMovil(index,table)
    {
      let indexopen=1
      let searchTableTable=table
      searchTableTable.tableTable=false
      let campoytabla   
      if(this.tableTable!==true) // si esta abierta alguna table
      {
        this.dataGet[this.namePath].data[this.tableIndex][this.tabla].splice(this.tableTable+1,1) 
      }
      if(index!==this.tableTable) // si la posicion del tr es diferente a la del tr con el table abierto
      {
        this.opentabletable=index

        if(index>this.tableTable && this.tableTable!==true)
        {
          index=index-1
        }         
        this.dataGet[this.namePath].data[this.tableIndex][this.tabla].splice(index+1,0,searchTableTable)  
        this.tableTable = index
      }
      else{
        if(this.opentabletable===index)
        {
          this.tableTable=true
        }
        else{
          this.opentabletable=index
          if(index>this.tableTable && this.tableTable!==true)
          {
            index=index-1
          }
          this.dataGet[this.namePath].data[this.tableIndex][this.tabla].splice(index+1,0,searchTableTable)  
        }          
      }       
    }, 
    inputData(data)
    {
      let table=data.split('/')[0]
      let campo=data.split('/')[1]
      return {table: table ,campo: campo }
    },
    openModalMovil(options,items)
    {
      this.tableModal= { 
        title: options.btn,
        value: true,
        items: items,
        options: options
      }  
    }
  }
}
</script>
<style>
.sw-table-dark > thead tr th, .sw-table-dark > thead tr th:hover 
{
  background: #525173 !important;
  color: white !important;
  border: 1px solid #ccc
}
.paginatable .page-link{
  color: #525173 ;
}
.paginatable .active .page-link{
  background: #525173 ;
  border-color:#525173;
}
.paginatable .page-link{
  border-top: none;
}
.paginatable .page-link:focus{
    box-shadow: none;
}
.paginatable .page-item span:first-child{
  border-top-left-radius:0 !important;
}
.paginatable .page-item:last-child .page-link{
  border-top-right-radius:0 !important;
}
.tabletableinput input{
  margin-bottom:0
}
.tabletableinput td{
  padding-top: 7px;
  background: rgba(255, 255, 255, 0.035)
}
.tabletableinput .multiselect{
  margin-bottom: 5px;
}
.popover-body legend 
{
  text-align:left !important
}
.bg-hover-td
{
  background: rgba(0, 0, 0, 0.075) 
}
</style>